import { useMapColorState } from "../../store/MapColorState";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { mapRegionState } from "../../store/MapRegionState";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { googleMapLanguageState } from "../../store/GoogleMapState";

const GoogleMapLoader = ({children}) => {
  const {isGoogleMap} = useMapColorState();
  const {i18n} = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const region = useRecoilValue(mapRegionState);
  const [promise, setPromise] = useState(null);
  const setGoogleMapLanguage = useSetRecoilState(googleMapLanguageState);

  let _promise = promise;
  const langChange = i18n.language !== language
  if (isGoogleMap && (!promise || langChange)) {
    const apiKey= process.env.REACT_APP_GOOGLEMAP_API_KEY;
    const mapOption = {
      apiKey,
      region,
      language:i18n.language,
    }
    _promise = loadGoogleMapScript(mapOption, langChange, () => {
      setGoogleMapLanguage(i18n.language);
    });

    setLanguage(i18n.language);
    setPromise(_promise);
  }

  return (
    <Inner promise={_promise}>
      {children}
    </Inner>
  );
};

const Inner = ({children, promise}) => {
  if (promise) {
    promise.read()
  }
  return (
    children
  );
};

const loadGoogleMapScript = (mapOption, langChange, changeLangCallback) => {

  const promise = new Promise((resolve) => {
    if (window.google && !langChange) {
      resolve();
      return;
    }

    const loadScript = (callback) => {
      //StrictModeで2回実行され、2回スクリプトをロードしないようにするための対処
      if (window.GOOGLE_MAP_LOADING) {
        const timer = setInterval(() => {
          if (window.GOOGLE_MAP_LOADED) {
            clearInterval(timer);
            resolve();
          }
        }, 1);
        return;
      }

      window.GOOGLE_MAP_LOADING = true;
      const script = document.createElement('script');
      script.type = 'text/javascript';
      const src = ['https://maps.googleapis.com/maps/api/js?libraries=geometry,places&callback=GOOGLE_MAP_INITIALIZE'];
      if (mapOption.apiKey) {
        src.push(`&key=${mapOption.apiKey}`);
      }
      if (mapOption.language) {
        src.push(`&language=${mapOption.language}`);
      }
      if (mapOption.region) {
        src.push(`&region=${mapOption.region}`);
      }
      script.src = src.join('');
      document.getElementsByTagName('head')[0].appendChild(script);

      window.GOOGLE_MAP_INITIALIZE = () => {
        window.GOOGLE_MAP_LOADING = false;
        window.GOOGLE_MAP_LOADED = true;
        if (callback) callback();
        resolve();
      }
    };

    const changeLang = () => {
      //Destroy old API
      document.querySelectorAll('script[src^="https://maps.googleapis.com"]').forEach(script => {
        script.remove();
      });
      if(window.google) delete window.google.maps;
      loadScript(changeLangCallback);
    };

    if (!langChange) {
      loadScript();
    } else {
      changeLang();
    }

  });

  return wrapPromise(promise);
};

const wrapPromise = (promise) => {
  let status = 'pending';
  let result;

  const suspender = promise.then(
    (r) => {
      status = 'fulfilled';
      result = r;
    },
    (e) => {
      status = 'rejected';
      result = e;
    });

  const read = () => {
    if (status === 'pending') {
      throw suspender;
    } else if (status === 'rejected') {
      throw result;
    } else {
      return result;
    }
  };

  return {read};
}

export default GoogleMapLoader;